/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class OfferSetsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get default offer set (deprecated, use OfferSetsApi#get(&quot;default&quot;) instead)
     * @param impression 
     */
    public default(impression?: boolean, __unused?: any): Observable<models.ApiOfferSet> {
        const path = '/membership/offer_sets';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (impression !== undefined) {
            queryParameters['impression'] = impression ? '1' : '0';
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiOfferSet>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get an offer set
     * @param id 
     * @param impression 
     */
    public get(id?: string, impression?: boolean, __unused?: any): Observable<models.ApiOfferSet> {
        const path = '/membership/offer_sets/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (impression !== undefined) {
            queryParameters['impression'] = impression ? '1' : '0';
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiOfferSet>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Returns list of all offer sets
     */
    public getAllOfferSets(__unused?: any): Observable<PagedArray<models.ApiOfferSet>> {
        const path = '/offer_sets/all';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiOfferSet>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Returns a list of embedded offer sets
     */
    public getAllEmbeddedOfferSets(__unused?: any): Observable<PagedArray<models.ApiOfferSet>> {
        const path = '/offer_sets/embedded';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiOfferSet>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
